// @flow

import React, { type Node } from 'react';

import { Captcha } from '@tectonics/captcha/components';
import { useFormHasBeenSent } from '@tectonics/prs/form-status';
import { useUserInputValue } from '@tectonics/prs/user-input-values';
import { useIncomingPayment, getCountry, getRecaptchaSiteKey } from '@tectonics/prs/incoming-payment';
import { useUserInputValidationError, type UserInputValidationError, serverErrorMessage } from '@tectonics/prs/validation';
import { useAutoResetCaptcha } from '@tectonics/captcha';

import { Field } from '../../../commons/molecules';

export function FieldCaptchaToken(): Node {
  const validationError = useUserInputValidationError('captchaToken');
  const [, handleChange] = useUserInputValue('captchaToken');
  const formHasBeenSent = useFormHasBeenSent();
  const incomingPayment = useIncomingPayment();
  const siteKey = getRecaptchaSiteKey(incomingPayment);
  const shouldResetCaptcha = useAutoResetCaptcha();

  return (
    <Field
      error={<ValidationErrorMessage validationError={validationError} />}
      hasError={formHasBeenSent && !!validationError}
    >
      <Captcha style={{ marginTop: '1em' }} siteKey={siteKey} setCaptchaToken={handleChange} shouldResetCaptcha={shouldResetCaptcha} />
    </Field>
  );
}


type ValidationErrorMessageProps = {|
  validationError: ?UserInputValidationError,
|};


function ValidationErrorMessage({ validationError }: ValidationErrorMessageProps): Node {
  const fallback = useInvalidErrorByCountry();

  if(!validationError) {
    return fallback;
  }

  if (validationError.id === 'server-error') {
    return serverErrorMessage(validationError.payload, fallback);
  }

  return fallback;
}

function useInvalidErrorByCountry(): string {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);

  switch (country) {
    case 'br':
      return 'Resolva o desafio captcha.';

    case 'mx':
    case 'co':
    case 'cl':
    case 'pe':
    case 'ec':
    case 'ar':
      return 'Resuelve el desafío de captcha.';

    default:
      throw new Error(`Field Captcha Token: ${country} has no Invalid Name Error Message`);
  }
}
